import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';

import useFormData from '../../../hooks/useFormData';
import Container from '../../../components/Theme/Form';
import Input from '../../../components/Input';
import Select from '../../../components/Select';
import useAxios from '../../../hooks/useAxios';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Gallery from '../../../components/Gallery';

//let getInit
let cat;

const NewPeoduct = ({ getInit, action }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const axios = useAxios();

  const [summary, setSummary] = React.useState([]);
  const [images, setImages] = React.useState([]);
  const [value, setValue] = React.useState('');
  const [categories, setCategories] = React.useState([]);
  const [categoriesBestgreen, setCategoriesBestgreen] = React.useState([]);
  const [reset, setReset] = React.useState(false);

  const endpoint = 'api/' + process.env.REACT_APP_BACKEND_VERSION + location.pathname;

  const { formData, onChange, setFormData } = useFormData();

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(action,formData.id)
    if (!action || !formData.id) {
      axios
        .postData(
          { ...formData, description: value, summary: JSON.stringify(images) },
          'api/v1' + location.pathname
        )
        .then((response) => {
          if (response && response.data && response.data.id && getInit) {
            return navigate('../../productos');
          }
        });
    } else {

      const new_img_set = [...summary, ...images];
      console.log(new_img_set)
      axios
        .putData({ ...formData, description: value, summary: JSON.stringify(new_img_set) }, 'api/v1' + location.pathname)
        .then((response) => {
          if (response && response.data && response.data.id && getInit) {
            return navigate('../../productos');
          }
        });
    }
  };

  getInit = () => {
    axios.getData(formData, endpoint).then((response) => {
      if (response && response.data) {
        setReset(true);
        setFormData(response.data);
        setValue(response.data.description);
        if (response.data.summary) {
          const _summary = JSON.parse(response.data.summary);
          setSummary(_summary.imagenes || []);
        }
        setTimeout(() => {
          setReset(false);
        }, 500);
      }
    });
  };

  cat = () => {
    axios.getData(formData, endpoint + '/categories').then((response) => {
      if (response && response.data && response.data.categories) {
        setCategories(response.data.categories);
      }
      if (response && response.data && response.data.categoriesBestgreen) {
        setCategoriesBestgreen(response.data.categoriesBestgreen);
        getInit();
      }
    });
  };

  React.useEffect(() => {
    cat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //console.log([...summary, ...images])

  return (
    <form onSubmit={onSubmit}>
      {formData && !reset && (
        <Container>
          {/* Encabezado con gradiente */}
          <Paper
            elevation={0}
            sx={(theme) => ({
              mb: 3,
              p: 3,
              borderRadius: 3,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              color: theme.palette.getContrastText(theme.palette.primary.main),
            })}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Box>
                <Typography variant="overline" sx={{ opacity: 0.9 }}>
                  Gestión de Productos
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                  {formData.label || 'Nuevo producto'}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Completa la información y guarda los cambios.
                </Typography>
              </Box>
              <Tooltip title="Guardar">
                <span>
                  <IconButton
                    type="submit"
                    size="large"
                    sx={{
                      bgcolor: 'rgba(255,255,255,0.15)',
                      color: 'common.white',
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
                    }}
                  >
                    <SaveRoundedIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Paper>

          <Grid container spacing={3} alignItems="stretch">
            {/* Columna izquierda */}
            <Grid item xs={12} md={8}>
              <Card elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <CardHeader
                  title="Información básica"
                  subheader="Datos principales del producto"
                  sx={{ pb: 1 }}
                />
                <Divider />

                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Select
                        placeholder="Categoría"
                        items={Array.from(new Map(categories.filter(item => item.label && item.label.trim() !== "").map(item => [item.label, item])).values())}
                        defaultValue={formData.categoria_id}
                        data={formData}
                        onChange={setFormData}
                        name="categoria_id"
                        label="Categoría"
                      />
                    </Grid>                    

                    <Grid item xs={12} md={6}>
                      <Select
                        placeholder="Estado"
                        items={[
                          { label: 'Encendido', id: 8 },
                          { label: 'Apagado', id: 7 },
                        ]}
                        defaultValue={formData.status}
                        data={formData}
                        onChange={setFormData}
                        name="status"
                        label="Estado"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Input
                        placeholder="Título"
                        defaultValue={formData.label}
                        onChange={onChange}
                        name="label"
                        label="Título"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Input
                        placeholder="Precio referencia"
                        defaultValue={formData.price}
                        onChange={onChange}
                        name="price"
                        type="number"
                        label="Precio referencia"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Select
                        placeholder="Categoría Bestgreen"
                        items={categoriesBestgreen}
                        defaultValue={formData.tags}
                        data={formData}
                        onChange={setFormData}
                        name="tags"
                        label="Categoría Bestgreen"
                      />
                    </Grid>
                  </Grid>

                  {/* Descripción enriquecida */}
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1.25, fontWeight: 600 }}>
                      Descripción
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        overflow: 'hidden',
                        '& .ql-toolbar': { border: 'none', borderBottom: (t) => `1px solid ${t.palette.divider}` },
                        '& .ql-container': { border: 'none', minHeight: 150 },
                      }}
                    >
                      <ReactQuill theme="snow" value={value} onChange={setValue} />
                    </Paper>

                    {formData.slug && (
                      <Box sx={{ mt: 1.5 }}>
                        <Button
                          href={formData.slug}
                          target="_blank"
                          rel="noreferrer"
                          variant="text"
                          size="small"
                        >
                          Recurso de extracción
                        </Button>
                      </Box>
                    )}
                  </Box>
                </CardContent>

                <CardActions sx={{ px: 2, pb: 2, pt: 0, justifyContent: 'flex-end' }}>
                  <Button startIcon={<SaveRoundedIcon />} variant="contained" size="large" type="submit">
                    Guardar
                  </Button>
                </CardActions>
              </Card>

              {/* Resumen de imágenes extraídas */}
              {summary && summary.length > 0 && (
                <Card elevation={2} sx={{ borderRadius: 3, mt: 3 }}>
                  <CardHeader title="Imágenes extraídas" subheader="Previsualización" />
                  <Divider />
                  <CardContent>
                    <ImageList variant="masonry" cols={3} gap={8}>
                      {summary.map((src, key) => (
                        <ImageListItem key={key}>
                          <a rel="noreferrer" href={src} target="_blank">
                            <img src={src} alt="" loading="lazy" style={{ width: '100%', borderRadius: 12 }} />
                          </a>
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </CardContent>
                </Card>
              )}
            </Grid>

            {/* Columna derecha */}
            <Grid item xs={12} md={4}>
              <Card
                elevation={2}
                sx={{
                  borderRadius: 3,
                  position: { md: 'sticky' },
                  top: { md: 16 },
                  height: '100%',
                }}
              >
                <CardHeader
                  avatar={<ImageRoundedIcon />}
                  title="Galería"
                  subheader="Gestiona las imágenes del producto"
                />
                <Divider />
                <CardContent>
                  <Gallery images={images} setImages={setImages} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      )}
    </form>
  );
};

export default NewPeoduct;
